import { Reach } from '@/types/types';

export const reaches: Reach[] = [
	{
		id: '13455542-bd20-4b95-b55d-fc248d324dd7',
		name: 'Österreich',
	},
	{
		id: 'b4e4a942-ab63-4e4c-91c4-f3eed80b220d',
		name: 'Niederösterreich',
	},
	{
		id: '38652a92-f830-410c-aac3-940aadf2a256',
		name: 'Oberösterreich',
	},
	{
		id: '862bc56b-cfad-42bd-b19e-87be4deb4fb1',
		name: 'Wien',
	},
	{
		id: 'b5d7dd9b-7bfa-4bf2-be28-c3ba984d55b6',
		name: 'Burgenland',
	},
	{
		id: '45067442-3bd2-41a0-ba6e-8e0d2b1b091a',
		name: 'Steiermark',
	},
	{
		id: 'bdcc1924-6710-4105-a3ad-344ac79def74',
		name: 'Kärnten',
	},
	{
		id: '4ff4bda2-d9ba-4bef-a33f-fbaab043005c',
		name: 'Salzburg',
	},
	{
		id: '051bf73d-e895-4854-89ce-ac18cb05240f',
		name: 'Tirol',
	},
	{
		id: '7c96d88d-1c69-45a3-8727-1718a7f07967',
		name: 'Vorarlberg',
	},
];
